import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { withRouter } from "react-router-dom"
import LazyLoadWrapper from "components/common/LazyLoadWrapper"
import history from "app/history"
import cx from "classnames"
import ImagePlaceholder from "assets/images/imageplaceholder.png"
import "./index.scss"
import { amountFormatter } from "helpers/util"
import { hexToRgb } from "helpers/contrast"
class Card extends Component {
  render() {
    const {
      data,
      isBundle,
      isFeatured,
      school: { schoolData },
    } = this.props
    return (
      <div className={cx("course-card", isBundle && "-bundle")}>
        <div className="card-image">
          <LazyLoadWrapper
            onError={(e) => (e.target.src = ImagePlaceholder)}
            src={`${data.image}`}
            effect="blur"
            width="100%"
            height="100%"
          />
        </div>
        <div className="card-content">
          {data.subcategory ? (
            <p
              className="subcategory"
              style={{
                color: schoolData?.primary_color,
                borderColor: `rgba(${hexToRgb(
                  schoolData?.primary_color || ""
                )}, 0.2)`,
              }}
            >
              {data.subcategory}
            </p>
          ) : null}
          {data.category ? (
            <span className="category">{data.category}</span>
          ) : null}
          <h2 className="title">{data.name}</h2>
          <p className="description">
            {isBundle ? (
              <>
                <p>
                  <span className="icon-bundle" />
                  {data.courses?.length} Courses included
                </p>
                <p>
                  <span className="icon-outline" />
                  {data.units || "No"} units
                </p>
              </>
            ) : (
              data.description
            )}
          </p>
        </div>
        <button
          className="card-button"
          onClick={() => {
            if (isBundle) {
              history.push(`/course-bundle/${data.slug}`)
            } else {
              history.push(`/course/${data.slug}`)
            }
          }}
          style={{ backgroundColor: schoolData?.primary_color }}
        >
          {(data.show_fee || isBundle) && !isFeatured ? (
            data.fee ? (
              <span className="fee">{`P${amountFormatter(data.fee)}`}</span>
            ) : (
              <span className="fee">Free</span>
            )
          ) : null}
          <p className="text">View {isBundle ? "Bundle" : "Course"}</p>
          <span className="icon-right" />
        </button>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  school: state.schoolReducer,
})

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(Card)
